import { render, staticRenderFns } from "./ManageMoveUser.vue?vue&type=template&id=7a601130&scoped=true"
import script from "./ManageMoveUser.vue?vue&type=script&lang=js"
export * from "./ManageMoveUser.vue?vue&type=script&lang=js"
import style0 from "./ManageMoveUser.vue?vue&type=style&index=0&id=7a601130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a601130",
  null
  
)

export default component.exports